import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root'
})
export class DroitsService {
	constructor(
		private http: HttpClient
	) { }

	getDroitsForInstruction(instructionid: any, options: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.instruction:droits',
			params: {
				id: instructionid,
				application: 'GESTMAT',
				options: options
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	checkDroitsInstructionRead(instruction: any, droit: any) {

	}
	checkDroitsInstructionUnique(instruction: any, listInstruction: any, droit: any) {

	}
	checkDroitsInstructionWrite(instruction: any, droit: any) {

	}

	checkDroitsDemandeRead(demande: any, droit: any) {

	}
	checkDroitsDemandeUnique(demande: any, droit: any) {

	}
	checkDroitsDemandeWrite(demande: any, droit: any) {

	}

	checkDroitsEtapeRead(etape: any, droit: any) {

	}
	checkDroitsEtapeUnique(etape: any, droit: any) {

	}
	checkDroitsEtapeWrite(etape: any, droit: any) {

	}

	checkDroitsFormulaireCreate(formulaire: any, droit: any) {
		if (droit.FORMULAIRES[formulaire.key] && !droit.FORMULAIRES[formulaire.key].c)
			return false
		else
			return true
	}
	checkDroitsFormulaireRead(formulaire: any, droit: any) {
		if (droit && droit.FORMULAIRES[formulaire.form.key] && !droit.FORMULAIRES[formulaire.form.key].r)
			return false
		else
			return true
	}
	checkDroitsFormulaireUnique(formulaire: any, droit: any) {
		if (droit.FORMULAIRES[formulaire.key] && droit.FORMULAIRES[formulaire.key].u && droit.DEMANDE_FORMULAIRE_COUNT[formulaire.key])
			return true
	}
	checkDroitsFormulaireWrite(formulaire: any, droit: any) {
		if (droit.FORMULAIRES[formulaire.key] && !droit.FORMULAIRES[formulaire.key].w)
			return false
		else
			return true
	}

	checkDroitsDocumentCreate(document: any, droit: any) {
		if (droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].c)
			return false
		else
			return true
	}
	checkDroitsDocumentRead(document: any, droit: any) {
		if (droit && droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].r)
			return false
		else
			return true
	}
	checkDroitsDocumentUnique(document: any, droit: any) {
		if (droit.DOCUMENTS[document.document.type.key] && droit.DOCUMENTS[document.document.type.key].u && droit.DEMANDE_DOCUMENT_COUNT[document.document.type.key])
			return true
	}
	checkDroitsDocumentWrite(document: any, droit: any) {
		if (droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].w)
			return false
		else
			return true

	}

	checkDroitsRDVCreate(rdv: any, droit: any) {
		if (droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].c)
			return false
		else
			return true
	}
	checkDroitsRDVRead(rdv: any, droit: any) {

		if (droit && droit.FORMULAIRES[rdv.form.key] && rdv.form.type === 1 && !droit.FORMULAIRES[rdv.form.key].r)
			return false
		else
			return true
	}
	checkDroitsRDVUnique(rdv: any, droit: any) {
		if (droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].w)
			return false
		else
			return true
	}
	checkDroitsRDVWrite(rdv: any, droit: any) {
		if (droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].w)
			return false
		else
			return true
	}

	checkDroitsCourrierCreate(courrier: any, droit: any) {
		if (droit.COURRIERS[courrier.key] && !droit.COURRIERS[courrier.key].c)
			return false
		else
			return true
	}
	checkDroitsCourrierRead(courrier: any, droit: any) {
		if (droit && droit.COURRIERS[courrier.courrier.key] && !droit.COURRIERS[courrier.courrier.key].r)
			return false
		else
			return true
	}
	checkDroitsCourrierUnique(courrier: any, droit: any) {
		if (droit.COURRIERS[courrier.key] && droit.COURRIERS[courrier.key].u && droit.DEMANDE_COURRIER_COUNT[courrier.key])
			return true
	}
	checkDroitsCourrierWrite(courrier: any, droit: any) {
		if (droit.COURRIERS[courrier.courrier.key] && !droit.COURRIERS[courrier.courrier.key].w)
			return false
		else
			return true
	}
}
